/* Fixed bottom tab bar, mobile only. Markup: snippets/mobile-tab-bar.liquid
   The tab bar stays visible above the open mobile menu drawer, so its openers must close the
   menu first: "Categorie" toggles it, Search/Cart swap it for their own drawer. */
if (!customElements.get("mobile-tab-bar")) {
  class MobileTabBar extends HTMLElement {
    connectedCallback() {
      this.onClickEvent = this.onClickEvent || this.onClick.bind(this);
      // Capture phase: runs before the drawer-opener's own click handler on its button
      this.addEventListener("click", this.onClickEvent, true);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClickEvent, true);
    }

    onClick(event) {
      const opener = event.target.closest("drawer-opener");
      const menu = document.getElementById("Drawer-MobileNav");
      if (!opener || !menu || !menu.isOpen()) return;

      menu.closeDrawer();
      if (opener.dataset.drawer === "#Drawer-MobileNav") {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  customElements.define("mobile-tab-bar", MobileTabBar);
}
